import { Redirect, Switch } from "polyrouter";
import PriorityInsights from "./Priority/PriorityInsights";
import InsightCategories from "./Categories/InsightCategories";
import PriorityInsightsDetails from "./Details/PriorityInsightsDetails";
import DeviceDetailsRouter from "../Manage/Inventory/View/DeviceDetailsRouter";
import { RoomDetailsRouter } from "../Manage/Rooms/View/RoomDetails";
import SiteDetailsRouter from "../Manage/Sites/View/SiteDetailsRouter";
import { ProtectedRoute, ProtectedAppRoute } from "TsRoleGuards";

let InsightRouter = () => (
  <Switch nest>
    <ProtectedAppRoute
      path="/priority"
      Component={PriorityInsights}
      requirement="GET_EPISODES"
    />
    <ProtectedAppRoute
      path="/categories"
      Component={InsightCategories}
      requirement="GET_EPISODES"
    />
    <ProtectedAppRoute
      path="/details/:id/insight-device/:deviceId"
      Component={DeviceDetailsRouter}
      requirement="GET_EPISODES"
    />
    <ProtectedAppRoute
      path="/details/:id/insight-site/:siteId"
      Component={SiteDetailsRouter}
      requirement="GET_EPISODES"
    />
    <ProtectedAppRoute
      path="/details/:id/insight-room/:roomId"
      Component={RoomDetailsRouter}
      requirement="GET_EPISODES"
    />
    <ProtectedAppRoute
      path="/details/:id"
      Component={PriorityInsightsDetails}
      requirement="GET_EPISODES"
    />
    <ProtectedRoute nest path="/" requirement="GET_EPISODES">
      <Redirect nest to="priority" />
    </ProtectedRoute>
  </Switch>
);
export default InsightRouter;
